import { ReactComponent as CollapseIcon } from 'assets/icons/collapse.svg';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

import { CurrentPresenceHeaderProps } from './CurrentPresenceHeader.types';
import * as Styled from './CurrentPresenceHeader.styles';

export const CurrentPresenceHeader = ({ isAllNodesExpanded, handleToggleAll }: CurrentPresenceHeaderProps) => {
  const { formatMessage } = useLocale();

  return (
    <Styled.Header>
      <Styled.ExpandAllWrapper>
        <Styled.ToggleExpand
          data-testid="toggle-expand-button"
          checked={isAllNodesExpanded}
          onClick={handleToggleAll}
          icon={<CollapseIcon />}
          checkedIcon={<ExpandIcon />}
        />
      </Styled.ExpandAllWrapper>
      <Styled.ColumnsWrapper>
        <Styled.NameColumns>
          <Styled.NameColumnHeader>
            {formatMessage({ id: AppMessages['events.currentPresence.header.code'] })}
          </Styled.NameColumnHeader>
          <Styled.NameColumnHeader>
            {formatMessage({ id: AppMessages['events.currentPresence.header.name'] })}
          </Styled.NameColumnHeader>
        </Styled.NameColumns>
        {/* Spans the four counter columns; the trailing 1fr spacer and the action column stay empty. */}
        <Styled.CountersBackground>
          <Styled.ColumnHeader $weight="bold">
            {formatMessage({ id: AppMessages['events.currentPresence.header.peopleCount'] })}
          </Styled.ColumnHeader>
          <Styled.ColumnHeader $weight="medium">
            {formatMessage({ id: AppMessages['events.currentPresence.header.zone'] })}
          </Styled.ColumnHeader>
          <Styled.ColumnHeader $weight="medium">
            {formatMessage({ id: AppMessages['events.currentPresence.header.subzones'] })}
          </Styled.ColumnHeader>
          <Styled.ColumnHeader $weight="medium">
            {formatMessage({ id: AppMessages['events.currentPresence.header.total'] })}
          </Styled.ColumnHeader>
        </Styled.CountersBackground>
      </Styled.ColumnsWrapper>
    </Styled.Header>
  );
};
